export default {"src":"/_next/static/media/icon-housesWithLand.9ba7ff66.svg","height":26,"width":29,"blurWidth":0,"blurHeight":0};